import { getContactPath, getOfferPath, getFlatPath } from "../../utils/paths";

// Reduced 10 % deposit promo — open-ended, no end date in the copy.
// Switching it off hides the homepage badge and the popup and puts the
// 20 % / 80 % split back on /financovanie and in the FAQ.
export const PROMO_ACTIVE = true;

// v2 = "Akcia pokračuje" round: visitors who clicked through the summer
// popup should still see once that the promo goes on.
export const PROMO_POPUP_SEEN_KEY = "bell_promo_popup_seen_v2";
export const PROMO_POPUP_CTA_KEY = "bell_promo_popup_cta_v2";
export const POPUP_REPEAT_AFTER_MS = 7 * 24 * 60 * 60 * 1000;
export const POPUP_DELAY_MS = 4000;
export const POPUP_SCROLL_THRESHOLD = 0.25;

// No popup where its CTA already points to, or mid flat-detail funnel.
const excludedPrefixes = [getOfferPath(), getContactPath(), getFlatPath()];

export const isPopupExcludedPath = (pathname: string) =>
  excludedPrefixes.some((prefix) => pathname.startsWith(prefix));
